import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
global.Rails = Rails;
Turbolinks.start()
ActiveStorage.start()

require.context('../images', true)

import "@fontsource/open-sans/400.css"
import "@fontsource/open-sans/400-italic.css"
import "@fontsource/open-sans/700.css"
import "@fontsource/open-sans/700-italic.css"
import "@fontsource/open-sans/800.css"
import "@fontsource/open-sans/800-italic.css"
import "stylesheets/tailwind"
import "stylesheets/application"
import "stylesheets/forms"
import "stylesheets/modules/actiontext"

import "controllers"
